"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ensure = function (isValid, eventDef) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    return isValid(event) ? event : null;
}; };
exports.default = ensure;
